<template>
  <div>
    <p v-if="showPaymentChoice">
      Hai scelto di effettuare il pagamento tramite
      <b>Bonifico</b>: il tuo ordine è in attesa di conferma.
    </p>
    <div class="dea-heading--regular__s generic-container generic-container--order">
      Si prega di versare l'importo di €
      <b v-if="order.ecommerce_data.total">{{ order.ecommerce_data.total }}</b>
      <b v-else>{{ order.sale_price }}</b>
      :
      <br />
      <br />
      <b>Deascuola Spa</b>
      <br />IBAN:
      <b class="dea-font-secondary-magenta">IT68Q0306901142006484910140</b>
      <br />Come causale segnare il numero d’ordine:
      <br />
      <b class="dea-font-secondary-magenta">{{ order.public_id }}</b
      >.
      <br />
      <br />Per velocizzare l’attivazione del corso, puoi inviare la disposizione di pagamento a
      <Links
        href="mailto:info@deaformazione.it"
        class-name="dea-links dea-links--generic-dark-grey"
        label-class="dea-heading--regular__s"
        >info@deaformazione.it</Links
      >
    </div>
    <p v-if="showPaymentChoice">Riceverai una mail con i dettagli per effettuare il bonifico.</p>
    <p v-if="showPaymentChoice">
      Appena il tuo ordine sarà confermato, riceverai nostra notifica per partecipare all'evento.
      <br />Tutti i dettagli saranno sempre a disposizione nella sezione
      <Links :href="config.myevents_url" class-name="dea-links dea-links--generic-dark-grey">'I miei eventi'</Links>
      della tua Area personale.
    </p>
    <p v-else>Appena il tuo ordine sarà confermato, riceverai nostra notifica per partecipare all'evento.</p>
    <h4 v-if="false" class="dea-heading--regular__ms">I tuoi dati di fatturazione</h4>
    <div v-if="false" class="dea-heading--regular__s generic-container generic-container--order">
      <b>{{ order.ecommerce_data.billing.first_name }} {{ order.ecommerce_data.billing.last_name }}</b>
      <br />
      <div v-if="order.ecommerce_data.billing.company">{{ order.ecommerce_data.billing.company }}</div>
      {{ order.ecommerce_data.billing.address_1 }} {{ order.ecommerce_data.billing.address_2 }}
      <br />
      {{ order.ecommerce_data.billing.postcode }} - {{ order.ecommerce_data.billing.city }}
      <br />
      {{ order.ecommerce_data.billing.city }}
      <br />
      <Links
        :href="`mailto:${order.ecommerce_data.billing.email}`"
        class-name="dea-links dea-links--generic-dark-grey"
        >{{ order.ecommerce_data.billing.email }}</Links
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Links from "@/components/elements/Links";

export default {
  name: "OrderConfirmationBodyPayment",
  components: {
    Links,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    showPaymentChoice: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters(["config"]),
  },
};
</script>
